module.exports = __webpack_public_path__ + "static/media/fresh-factory-ad3.3767732b.png";